export default function Meanings(props) {
  //console.log(props.definition);
  return (
    <div>
      <p>{props.definition.definition}</p>
    </div>
  );
}
